<template>
    <v-app id="reset_password" class="primary general-form-wrapper">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg4>
                        <v-form id="reset_password_form" method="post" :action="form.action" v-on:success="request_success" ref="reset_password_form">
                            <input type="hidden" name="rskey" v-model="rskey">
                            <input type="hidden" name="user_id" v-model="user_id">

                            <v-card class="elevation-1 pa-3">

                                <v-alert
                                        :value="errors.general!==''"
                                        type="error"
                                >
                                    {{errors.general}}
                                </v-alert>

                                <v-card-text>

                                    <div class="layout column align-center">
                                        <h1 class="flex my-4 primary--text">{{$t('reset_password.title')}}</h1>
                                    </div>

                                    <template v-if="!form.request_success">

                                        <p>{{$t('reset_password.form_description')}}</p>

                                        <v-text-field
                                                ref="password"
                                                name="password"
                                                :placeholder="$t('user.new_password')"
                                                type="password"
                                                :error-messages="errors.password"
                                        ></v-text-field>

                                        <v-text-field
                                                ref="confirm_password"
                                                name="confirm_password"
                                                :placeholder="$t('user.confirm_password')"
                                                type="password"
                                                :error-messages="errors.confirm_password"
                                        ></v-text-field>
                                    </template>

                                    <template v-else>
                                        {{$t('reset_password.msg_reset_success')}}
                                    </template>



                                </v-card-text>

                                <v-card-actions>
                                    <template v-if="!form.request_success">
                                        <v-btn block color="primary"
                                               type="submit"
                                               ref="submit"
                                               :loading="form.loading"
                                        >
                                            {{$t('action.submit')}}
                                        </v-btn>
                                    </template>
                                    <template v-else>
                                        <v-btn block color="primary" @click="goLogin">
                                            {{$t('forget_password.to_login_page')}}
                                        </v-btn>
                                    </template>
                                </v-card-actions>

                            </v-card>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import FormHandling from '~/utils/data/form-handling';
    import {UrlServices} from "~/utils/url-manager";
    import AppFooter from "~/components/AppFooter";

    export default {
        name: "ResetPassword",
        components: {AppFooter},
        data() {
            return {
                form: {
                    action: UrlServices.createUrl({'name': 'api_reset_password'}),
                    loading: false,
                    request_success: false
                },
                errors: {
                    general: "",
                    password: "",
                    confirm_password: ""
                },
                rskey: "",
                user_id: 0
            }
        },
        methods: {
            request_success() {
                this.form.request_success = true;
            },
            goLogin() {
                this.$router.push({ name: 'public_login'});
            }
        },
        mounted: function() {
            new FormHandling(this, "reset_password_form");
            this.rskey = this.$route.query.rskey;
            this.user_id = this.$route.query.user_id;
        }
    }
</script>

<style scoped>

</style>